import React, { useState } from "react"
import * as common from "./common"
import BaseShapeRoundedRect from "./BaseShapeRoundedRect"
import { yellow } from "@mui/material/colors"
import ElementText from "./ElementText"
import Svg from "./Svg"
import { useFill } from "./useFill"

const BusinessService = (props) => {
    const { x, y, width, label, highlight, highlightColor, fillColor } = props

    const hoverColor = yellow[200]
    const defaultColor = fillColor || yellow[100]

    const [fill, setFill] = useState(defaultColor)

    const { handleFill } = useFill({ defaultColor, hoverColor, highlight, highlightColor, setFill })

    return (
        <Svg {...props} defaultColor={defaultColor} hoverColor={hoverColor} setFill={handleFill}>
            <BaseShapeRoundedRect {...props} fill={fill} setFill={handleFill} />

            <svg x={width - 28} y={6}>
                <BaseShapeRoundedRect
                    x={x}
                    y={y}
                    width={18}
                    height={10}
                    r={4}
                    fill={fill}
                    stroke={common.outlineColor}
                    setFill={handleFill}
                />
            </svg>

            <ElementText {...props} label={label} />
        </Svg>
    )
}

export default BusinessService
